function getDetailsParams(firstArticleVehicle) {
  return firstArticleVehicle
    ? {
        makeId: Number(firstArticleVehicle.make.id),
        make: firstArticleVehicle.make.name,
        ...(firstArticleVehicle.model && {
          modelId: Number(firstArticleVehicle.model.id),
          model: firstArticleVehicle.model.name
        })
      }
    : {}
}

export const getInitialBreadcrumbsProps = async ({domain, i18n, pageName, newsDetailDomainResponse}) => {
  const firstArticleVehicle = newsDetailDomainResponse.vehicles[0]

  const [, breadcrumbsFromDomain = []] = await domain
    .get('get_news_dynamic_breadcrumbs_breadcrumb_use_case')
    .execute({pageName, params: getDetailsParams(firstArticleVehicle)})

  return breadcrumbsFromDomain.map(({label, ...rest}) => ({
    ...rest,
    label: i18n.t(label)
  }))
}
